<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout wrap mt-3>
      <v-flex xs6 text-xs-center v-for="i in 2" :key="alts[i]">
        <button class="hvr-scale" :class="vistos[i-1]?'bot-check-vis-cen':''" @click="currentText = i, $set(vistos,i-1,true)">
          <img :src="require('../../assets/Modulo 2/diapositiva-16-'+ i +'.png')" :alt="alts[i-1]">
        </button>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs12 lg8 v-if="text != ''">
        <transition name="custom" enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOutDown faster" mode="out-in">
          <p class="texto1 mt-4" :key="text">
            <span v-html="text"></span>
          </p>
        </transition>
      </v-flex>
    </v-layout>
    <modal-app v-model="modal" :fullscreen="false" width="700px">
      <h1 class="modal-title">Cálculo de estimaciones</h1>
      <p>Las estimaciones de reservas probadas + probables y las reservas probadas + probables+ posibles deben estar basadas en interpretaciones técnicas y comerciales razonables dentro del yacimiento o proyecto, incluyendo comparaciones con resultados exitosos em proyectos similares.</p>
    </modal-app>

    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 2/AUDIO 10'
    ]"></audio-player> 
  </div>
</template>

<script>
import { setTimeout } from 'timers';
export default {
  data() {
    return {
      dialogos: [
        "¡Muy bien! Respecto a las respuestas probables y posibles podemos afirmar que: <span class='instruccion'>haz clic en los iconos</span>" 
      ],
      alts: [
        "",
        ""
      ],
      modal: false,
      vistos: [false,false],
      currentText: 0
    }
  },
  computed: {
    text: function() {
      switch (this.currentText){
        case 1: return "Son aquellas reservas que tienen menor probabilidad de recuperación que las probadas, por ejemplo; en áreas adyacentes a reservas probadas donde la interpretación de datos tiene menos certeza.";
        case 2: return "Reservas con menor probabilidad de recuperación que las probables, por ejemplo; en áreas adyacentes a reservas probadas donde la interpretación de datos tiene menos certeza.";
        default: return ""
      }
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos) {
        setTimeout(()=>{
          this.modal = true
          this.$store.commit('nextShow', true)
        },8000)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
